import { useLocation } from '@reach/router'

const useIsViewingDashboard = () => {
  const location = useLocation()
  return location.pathname == '/'
}

export default useIsViewingDashboard
